import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useGroupUsersList } from '@shared/api/lib/group/group';
import {
  GroupUsersListParams,
  PaginatedGroupUserList,
} from '@shared/api/types';

/**
 * Paginated list of users belonging to a single child organisation. Drives the
 * nested organisation users page (reached from the Organisations table). The
 * `organization` param (child org UUID) is mandatory server-side, so callers
 * gate the query until it's known.
 */
export const useGetGroupUsers = (params: GroupUsersListParams) =>
  useGroupUsersList<PaginatedGroupUserList>(params, {
    request: useAxiosConfig(),
    query: {
      keepPreviousData: true,
      enabled: !!params.organization,
    },
  });
